module.exports = __webpack_public_path__ + "img/grupo-mexico.b3f12057.png";